import React from 'react';
import PropTypes from 'prop-types';

import Form from './Form';

class Card extends React.Component {
  constructor(props) {
    super(props);

    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick() {
    const { name, onButtonClick } = this.props;
    onButtonClick(name);
  }

  render() {
    const {
      name,
      location,
      sessionType,
      active,
      inactive,
      children,
    } = this.props;
    return (
      <div className={`k-card ${location.toLowerCase()}${active ? ' active' : ''}${inactive ? ' inactive' : ''}`}>
        <div className="k-card-title">
          <div className="location">
            {location}
            <span className="icon">{location.toLowerCase() === 'virtual' ? String.fromCharCode(59904) : String.fromCharCode(59088)}</span>
          </div>
          {name}
        </div>
        <div className="k-card-body">
          {children}
          {active
            ? null : (
              <div
                className="k-button"
                role="button"
                tabIndex="0"
                onClick={this.handleButtonClick}
                onKeyPress={this.handleButtonClick}
              >
                Schedule
              </div>
            )}
          {active ? <Form sessionType={sessionType} /> : null}
        </div>
      </div>
    );
  }
}

Card.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  sessionType: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  inactive: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default Card;
